import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import SpacerHorizontal from '@bubble-ui/atom-spacer-horizontal';
import SpacerVertical from '@bubble-ui/atom-spacer-vertical';
import ParagraphSecondary from '@bubble-ui/molecule-paragraph-body';
import { compose } from 'recompose';
import { withDesignVersion } from '@bubble-ui/provider-design-version';
import { getBackgroundColor, getInputTextColor } from '@bubble-ui/temp-form-element-colors';

var Row = /*#__PURE__*/function (_React$Component) {
  _inherits(Row, _React$Component);

  var _super = _createSuper(Row);

  function Row(props) {
    var _this;

    _classCallCheck(this, Row);

    _this = _super.call(this, props);
    _this.state = {
      hover: false
    };
    _this.ref = /*#__PURE__*/React.createRef();
    _this.onMouseIn = _this.onMouseIn.bind(_assertThisInitialized(_this));
    _this.onMouseOut = _this.onMouseOut.bind(_assertThisInitialized(_this));
    _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Row, [{
    key: "onMouseIn",
    value: function onMouseIn() {
      var _this$props = this.props,
          onMouseDown = _this$props.onMouseDown,
          hint = _this$props.hint;

      if (!hint && onMouseDown) {
        this.setState({
          hover: true
        });
      }
    }
  }, {
    key: "onMouseOut",
    value: function onMouseOut() {
      var _this$props2 = this.props,
          onMouseDown = _this$props2.onMouseDown,
          hint = _this$props2.hint;

      if (!hint && onMouseDown) {
        this.setState({
          hover: false
        });
      }
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(e) {
      var _this$props3 = this.props,
          onMouseDown = _this$props3.onMouseDown,
          hint = _this$props3.hint;

      if (hint) {
        e.preventDefault();
      } else if (onMouseDown) {
        onMouseDown();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          focused = _this$props4.focused,
          title = _this$props4.title,
          designVersion = _this$props4.designVersion,
          styleSheet = _this$props4.styleSheet,
          style = _this$props4.style,
          disabled = _this$props4.disabled;
      var _styleSheet$row = styleSheet.row,
          textWrapper = _styleSheet$row.textWrapper,
          item = _styleSheet$row.item;

      var rowStyle = _objectSpread(_objectSpread({}, style), {}, {
        flexGrow: 1,
        flexDirection: 'row',
        display: 'flex',
        background: getBackgroundColor({
          designVersion: designVersion,
          disabled: focused || this.state.hover || disabled
        }),
        height: styleSheet.dropdown.lineHeight
      });

      var textStyle = _objectSpread(_objectSpread({}, textWrapper), {}, {
        color: getInputTextColor({
          designVersion: designVersion,
          disabled: disabled
        })
      });

      return /*#__PURE__*/React.createElement("li", {
        onFocus: !disabled ? this.onMouseIn : null,
        onBlur: !disabled ? this.onMouseOut : null,
        onMouseOver: !disabled ? this.onMouseIn : null,
        onMouseOut: !disabled ? this.onMouseOut : null,
        onMouseDown: !disabled ? this.handleMouseDown : null,
        ref: this.ref,
        style: rowStyle
      }, /*#__PURE__*/React.createElement(SpacerHorizontal, {
        medium: true
      }), /*#__PURE__*/React.createElement("div", {
        style: item
      }, /*#__PURE__*/React.createElement(SpacerVertical, {
        small: true
      }), /*#__PURE__*/React.createElement(ParagraphSecondary, {
        bold: title,
        disabled: true
      }, /*#__PURE__*/React.createElement("span", {
        style: textStyle
      }, children)), title ? null : /*#__PURE__*/React.createElement(SpacerVertical, {
        small: true
      })), /*#__PURE__*/React.createElement(SpacerHorizontal, {
        medium: true
      }));
    }
  }]);

  return Row;
}(React.Component);

export default compose(withDesignVersion)(Row);
//# sourceMappingURL=row.js.map